<template>
  <div class="driver-wallet-qr-code main">
    <div v-if="role" class="wrapper no-scrollbar">
      <h1 class="subtitle" @click="$emit('close')">
        <i class="fa fa-chevron-left" style="margin-right: 4px" />
        {{ $t("driver.driver-payment-options") }}
      </h1>

      <div v-if="qrCode" class="qr-code">
        <img :src="qrCode" v-img-fallback="imgFallback" />
        <i class="fa fa-pencil-alt has-text-info" @click="clickUpload" />
      </div>
      <div v-else style="margin: 40px auto; text-align: center" @click="clickUpload">
        <p style="margin-bottom: 20px">
          <i class="fa fa-qrcode fa-7x" />
        </p>
        <a class="subtitle button is-link is-outlined">
          <i class="fa fa-camera-retro" />&nbsp;
          {{ $t("driver.upload-qr-code") }}
        </a>
      </div>

      <hr />

      <div v-if="bankAccount" class="notification is-warning" style="border-radius: 20px">
        <span class="button is-pulled-right is-rounded is-outlined is-white"
          style="padding: 9px; margin: -14px; z-index: 2" @click="
            editingBankAccount = true;
          showBankAccountForm = true;
          ">
          <i class="fa fa-pencil-alt has-text-info" />
        </span>
        <p class="subtitle" style="margin-bottom: 8px; margin-top: 0">
          Bank Transfer Details
        </p>
        <p>{{ bankAccount.bank_name }}</p>
        <p>
          {{ bankAccount.account_number }}
          <!-- <span class="is-pulled-right">Account Number</span> -->
        </p>
        <p>
          {{ bankAccount.name_on_account }}
        </p>
      </div>

      <div v-else>
        <div v-if="showBankAccountForm">
          <p class="subtitle" style="margin-bottom: 8px">Enter Bank Account</p>
          <div class="field">
            <label class="label">Select Bank</label>
            <div v-if="selectedBank" class="control tag is-medium is-dark" @click="selectedBank = null">
              {{ selectedBank }}&nbsp; &nbsp;
              <i class="fa fa-times-circle" />
            </div>
            <div v-else class="control buttons">
              <span v-for="b in banks" :key="b" class="button is-small is-rounded" @click="selectedBank = b">
                {{ b }}
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label">Account Number</label>
            <div class="control">
              <input class="input" v-model="accountNumber" type="text" placeholder="e.g 235890913412" />
            </div>
          </div>

          <div class="field">
            <label class="label">Name on Account</label>
            <div class="control">
              <input class="input" v-model="nameOnAccount" type="text" placeholder="e.g. John Doe" />
            </div>
          </div>

          <div class="field is-grouped is-pulled-right" style="margin-bottom: 20px">
            <div class="control">
              <button class="button is-link" @click="submitBankAccount">
                {{ $t("submit") }}
              </button>
            </div>
            <div class="control">
              <button class="button is-grey" @click="
                showBankAccountForm = false;
              editingBankAccount = false;
              ">
                {{ $t("cancel") }}
              </button>
            </div>
          </div>
        </div>
        <div v-else class="enter-bank" @click="clickBank">
          <p style="margin-bottom: 10px">
            <i class="fa fa-university fa-6x" />
          </p>
          <a class="subtitle button is-link is-outlined">
            <i class="fa fa-pencil-alt" />&nbsp;
            {{ $t("driver.enter-bank-account") }}
          </a>
        </div>
      </div>

      <input type="file" ref="fileQR" style="display: none" accept="image/png,image/jpeg,image/jpg,image/bmp"
        @change="uploadQRCodePic($event)" />

      <div style="height: 60px" />
    </div>
    <div v-else style="padding: 20px" @click="$emit('close')">
      <p class="subtitle">
        You must have a driver role to upload driver payment options.
      </p>
      <a class="button"><i class="fa fa-chevron-left" />&nbsp;Go Back</a>
    </div>
  </div>
</template>

<script>
import imageCompression from "browser-image-compression";

const shortid = require("shortid");

// import RideSetLocation from "@/components/RideSetLocation.vue";

export default {
  name: "DriverWalletQRCode",
  components: {
    // RideSetLocation,
  },
  props: {
    driverID: String,
    // workflow: Object, // transport workflow, should be array
  },
  data() {
    return {
      superDriverRole: null,
      editingBankAccount: false,
      showBankAccountForm: false,
      selectedBank: null,
      accountNumber: null,
      nameOnAccount: null,
      banks: [
        "Bangkok Bank (BBL)",
        "Kasikornbank (KBANK)",
        "Krungthai Bank (KTB)",
        "Siam Commerce Bank (SCB)",
        "TMB Bank (TMB)",
        "CIMB Thai Bank (CIMB)",
        "Bank of Ayudhya (BAY)",
        "Government Savings Bank (GSB)",
        "TMBThanachart Bank (TTB)",
      ],
      imgFallback: {
        loading: this.$store.state.menuItemPlaceholderPic, //birdProfilePic,
        error: this.$store.state.errorProfilePic,
      },
    };
  },
  computed: {
    role() {
      if (this.superDriverRole) return this.superDriverRole;
      return this.$store.getters.getDriverRole;
    },
    qrCode() {
      return this.role.data.qr_pic_url;
    },
    bankAccount() {
      if (this.editingBankAccount) return null;
      return this.role.data.bank_account;
    },
  },
  mounted() {
    if (this.driverID) {
      if (!this.isSuperUser()) return;
      this.getSuperDriverRole();
    }
  },
  methods: {
    getSuperDriverRole() {
      // super user is looking up another driver role data
    },
    clickBank() {
      this.selectedBank = null;
      this.showBankAccountForm = true;
      //   this.infoToast("Enter Bank Account Details<br>Coming Soon - Tomorrow!!");
    },
    clickUpload() {
      if (!this.qrCode) {
        var loader = this.loadingDots("blue");
        setTimeout(() => loader.hide(), 3000);
        return this.$refs.fileQR.click();
      }
      this.$swal({
        html: `<div style='font-size:2em'>Edit QR Code</div>`,
        title: `<i class='fa fa-qrcode fa-2x' style='color:navy; opacity:0.7'></i>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonColor: this.bulmaColor("danger"),
        cancelButtonText: "<i class='fa fa-bomb'></i> Delete",
        confirmButtonText: "<i class='fa fa-camera'></i> New",
      }).then((val) => {
        if (val.dismiss === "cancel") {
          this.saveQRCode(null);
        }
        if (val.value) {
          this.$refs.fileQR.click();
        }
      });
    },
    uploadQRCodePic(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 500,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.userID(), //"qrcode", //this.role.business_id,
                imageType: "qrcode",
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var url = res.data.compressed_image_url;
                  this.saveQRCode(url);
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
    saveQRCode(qrPicURL) {
      this.role.data.qr_pic_url = qrPicURL;
      var payload = {
        id: this.role.id,
        data: this.role.data,
      };
      this.console("updateRole", payload);
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.updateRoles(true);
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
    invalidBankAccount() {
      if (this.selectedBank && this.accountNumber && this.nameOnAccount) {
        return false; // false means bank account details are valid
      }
      this.errorToast("Enter complete bank account details");
      return true;
    },
    submitBankAccount() {
      if (this.invalidBankAccount()) return;
      this.role.data.bank_account = {
        bank_name: this.selectedBank,
        account_number: this.accountNumber,
        name_on_account: this.nameOnAccount,
      };
      var payload = {
        id: this.role.id,
        data: this.role.data,
      };
      this.console("updateRole", payload);
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateRoleData", payload)
        .then((res) => {
          console.log("updateRoleData", res);
          this.updateRoles(true);
          this.editingBankAccount = false;
        })
        .catch((err) => console.error("updateRoleData", err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  /* z-index: 21; */
  /* z-index: 1100; */
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}

.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  overflow: auto;
}

.subtitle {
  color: black;
  opacity: 0.7;
  font-weight: 450;
  margin-top: 6px;
}

img {
  width: 100vw;
  height: auto;
  border-radius: 20px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.qr-code {
  position: relative;
}

.qr-code .fa-pencil-alt {
  position: absolute;
  right: 2px;
  margin-top: 2px;
  padding: 9px;
  border: 1px solid lightgray;
  border-radius: 20px;
}

.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}

.fa-search {
  color: lightskyblue;
}

.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}

/* input::-webkit-input-placeholder {
  color: #2693da !important;
  font-weight: 500;
  opacity: 0.8;
} */
.enter-bank {
  margin: 40px auto;
  text-align: center;
}

.label {
  font-weight: 450;
}

.notification {
  padding: 16px;
}
</style>